var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-count-container"},[_c('AppText',[_vm._v(_vm._s(_vm.$t('campaigns.general.files')))]),_c('AppText',{attrs:{"type":"contentcount"}},[_vm._v(_vm._s(_vm.contentCount))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }